'use strict';
const formHelpers = require('../checkout/formErrors');
const giftCardHelpers = require('../helper/giftCardHelper');
const basketHelper = require('../helper/basketHelper');
const checkoutConstants = require('../checkoutConstants');

/**
 * Displays an error modal with the given content.
 * @param {string} content The content to display in the modal.
 */
function errorModal(content) {
    const errorModalDetails = window.resources.errorModalDetails || {};
    const errorModalTitle = errorModalDetails.title || 'ERROR';
    const errorModalButtonText = errorModalDetails.buttonText || 'OK';

    $.modal({
        title: errorModalTitle,
        content: content,
        customClasses: 'modal--error',
        buttons: [
            `<button class="btn btn-primary px-0" data-dismiss="modal">${errorModalButtonText}</button>`
        ]
    });
}

/**
 * Updates the forecasted rewards message. "You are earning $x.xx in Rewards on this purchase."
 * @param {Object} rewards The forecasted rewards data
 */
function updateForecastedRewards(rewards) {
    const $forecastedRewardsMessage = $('.js-forecasted-rewards');

    if (!$forecastedRewardsMessage.length) {
        return;
    }

    let calculatedRewards;

    if (rewards) {
        calculatedRewards = rewards.promoRewards || rewards.baseRewards;
    }

    if (!calculatedRewards || calculatedRewards.value === 0) {
        $forecastedRewardsMessage.hide();
    } else {
        $forecastedRewardsMessage.show().find('.js-loyalty-rewards-earning').text(calculatedRewards.formatted);

        // if we have strikethrough rewards in the message, update that too.
        if (rewards && rewards.baseRewards) {
            $forecastedRewardsMessage.find('s').text(rewards.baseRewards.formatted);
        }
    }
}

/**
 * Function that handles toggling the rewards balance/redemption banner, based on if loyalty is applied or not
 * @param {boolean} isRewardsApplied - if true, the rewards balance/redemption banner will show the loyalty applied experience
 * @param {string} textRemainingBalance - the remaining balance message to show when rewards are applied
 * @param {boolean} suppressActionButton - if true, we will not show the apply/remove button when toggling
 */
function rewardsBalanceBannerToggle(isRewardsApplied, textRemainingBalance, suppressActionButton) {
    const $rewardsBalanceRedemptionBanner = $('.rewards-balance-redemption-banner');
    const $redemptionBannerPrimaryText = $rewardsBalanceRedemptionBanner.find('.js-rewards-redemption-banner-primary-text');
    const $redemptionBannerSecondaryText = $rewardsBalanceRedemptionBanner.find('.js-rewards-redemption-banner-secondary-text');
    const $applyRewardsButton = $rewardsBalanceRedemptionBanner.find('.js-btn-apply-loyalty-rewards');
    const $removeRewardsButton = $rewardsBalanceRedemptionBanner.find('.js-btn-remove-loyalty-rewards');
    const $loyaltyForm = $('form.js-apply-loyalty-rewards');

    if (isRewardsApplied) {
        $redemptionBannerPrimaryText.text($redemptionBannerPrimaryText.data('appliedRewardsMsg'));
        $redemptionBannerSecondaryText.text(textRemainingBalance);

        $applyRewardsButton.hide();

        if (!suppressActionButton) {
            $removeRewardsButton.removeClass('d-none').show();
        }

        $loyaltyForm.attr('action', $loyaltyForm.data('cancelUrl'));
    } else {
        $redemptionBannerPrimaryText.text($redemptionBannerPrimaryText.data('availableRewardsMsg'));
        $redemptionBannerSecondaryText.text($redemptionBannerSecondaryText.data('availableRewardsMsg'));

        if (!suppressActionButton) {
            $applyRewardsButton.removeClass('d-none').show();
        }

        $loyaltyForm.attr('action', $loyaltyForm.data('applyUrl'));

        $removeRewardsButton.hide();
    }
}

module.exports = {
    init: (shouldRedirectOnSignUp) => {
        let loyaltySuccessMessage = sessionStorage.getItem('loyaltySuccessMessage');
        if (loyaltySuccessMessage) {
            $.alert({
                content: loyaltySuccessMessage,
                placement: 'banner',
                theme: 'info'
            });
            sessionStorage.removeItem('loyaltySuccessMessage');
        }
        $('.loyalty-form__toggle-btn').on('click', () => {
            $('.loyalty-form__summary').slideUp();
            $('.loyalty-form__toggle-form').slideDown();
        });

        /**
         * Sign up for loyalty membership on checkout page or order confirmation page.
         */
        $('#loyaltyShippingForm, form.checkout-registration').on('submit', function (e) {
            e.preventDefault();
            let $form = $(this);
            let url = $form.attr('action');
            let formData = $form.serialize();

            // if we're on the checkout page, append the shipping form to the POST data.
            const $shippingForm = $('#dwfrm_shipping');
            if ($shippingForm.length) {
                let shippingFormStr = $shippingForm.serialize();
                formData += '&' + shippingFormStr;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: formData
            }).done((data) => {
                if (data.success) {
                    // don't stop the spinner - the reload or redirect will do it.
                    if (data.redirectUrl && shouldRedirectOnSignUp) {
                        location.href = data.redirectUrl;
                    } else {
                        sessionStorage.setItem('loyaltySuccessMessage', $form.data('success-message'));
                        location.reload();
                    }
                } else if (data.error) {
                    $.spinner().stop();
                    // display error modal
                    errorModal(data.error);
                } else if (data.fields) {
                    $.spinner().stop();
                    // expand the loyalty section
                    $('.loyalty-form__summary').hide();
                    $('.loyalty-form__toggle-form').show();
                    // field errors
                    formHelpers.loadFormErrors($('#loyaltyShippingForm'), data.fields);
                }
            }).fail(() => {
                $.spinner().stop();
                // display error modal
                errorModal('Something went wrong. Please try again. If the problem persists, please contact customer support.');
            });
        });

        /**
         * Apply OR Remove loyalty rewards to order in checkout
         */
        $('form.js-apply-loyalty-rewards').on('submit', function (e) {
            e.preventDefault();
            let $form = $(this);
            let url = $form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url, // Loyalty-Apply
                type: 'POST',
                dataType: 'json',
                data: $form.serialize()
            }).done((data) => {
                $.spinner().stop();
                if (data.error) {
                    if (window.digitalData && window.digitalData.user && window.digitalData.user.rewardsRedeemed) {
                        delete window.digitalData.user.rewardsRedeemed;
                    }
                    errorModal(data.errorMessage);
                    return false;
                }
                const $availableCerts = $('.js-available-reward-certs');
                const $appliedRewardsAlert = $('.js-loyalty-applied-alert');
                const $loyaltyOrderSummary = $('.loyalty-discount');
                const $paymentOptionsBlock = $('.billing-payment-options-block');
                // loyalty rewards applied to cart
                if (data.result && data.result.appliedRewards) {
                    $form.data('applied-rewards', data.result.appliedRewards.value);
                    $form.attr('action', $form.data('cancelUrl'));

                    // If we are using the loyalty rewards drop down experience
                    if ($availableCerts.length && $appliedRewardsAlert.length) {
                        $availableCerts.slideUp();
                        $appliedRewardsAlert.find('.alert__content').html(data.result.appliedRewards.redeemedAmountText);
                        $appliedRewardsAlert.slide('show');
                    } else {
                        const rewardsAppliedMsg = $('.js-rewards-redemption-banner-primary-text').data('appliedRewardsMsg');
                        const toasterContent = `
                            <strong>${rewardsAppliedMsg}</strong>
                            <div>${data.result.appliedRewards.redeemedAmountText}</div>
                        `;

                        $.alert({
                            content: toasterContent,
                            theme: 'success',
                            placement: 'toast'
                        });

                        rewardsBalanceBannerToggle(true, data.result.appliedRewards.textRemainingBalance);
                    }

                    // update order summary
                    $loyaltyOrderSummary.removeClass('d-none').find('.loyalty-discount-total').text(`- ${data.result.totals.loyalty.formatted}`);
                    if (data && 'dtmLayer' in data && 'digitalData' in window) {
                        if (data.dtmLayer.user && window.digitalData.user) {
                            window.digitalData.user.rewardsRedeemed = data.dtmLayer.user.rewardsRedeemed;
                        }
                    }
                } else {  // Removing rewards that had been previously applied.
                    $form.data('applied-rewards', 0);
                    $form.attr('action', $form.data('applyUrl'));

                    // If we are using the loyalty rewards drop down experience
                    if ($availableCerts.length && $appliedRewardsAlert.length) {
                        $availableCerts.slide('show');
                        $appliedRewardsAlert.slideUp();
                    } else {
                        rewardsBalanceBannerToggle(false);
                    }

                    var checkedPaymentMethod = $('#paymentMethodsList').find('input[type=radio]:checked').val();
                    var isCcOrPbl = (checkedPaymentMethod === 'credit_card' || checkedPaymentMethod === 'PayByLink');
                    if (!isCcOrPbl) {
                        $('.submit-payment').removeClass('d-block').addClass('d-none');
                    }

                    // update order summary and billing section
                    $loyaltyOrderSummary.addClass('d-none');
                    if (data.paymentInstrumentsDetails && !data.paymentInstrumentsDetails.isNotFullyCoveredByAny) {
                        $('.gift-card-promo-entry-content').slideDown();
                    }
                    if (window.digitalData && window.digitalData.user && window.digitalData.user.rewardsRedeemed) {
                        delete window.digitalData.user.rewardsRedeemed;
                    }
                }
                $('.grand-total-sum').text(data.result.totals.grandTotal);

                // Toggle the disabled state of the Klarna payment option
                $('body').trigger('checkout:toggleKlarnaPaymentOption');

                // After Rewards applied or Removed update the PayPal config amount in data-braintree-config
                let $payPalButtonContainer = $('.js_braintree_paypal_billing_button');
                if ($payPalButtonContainer.length) {
                    $('body').trigger('checkout:updateBrainTreeConfig');
                }

                const $selectedPaymentOption = $('#selectedPaymentOption');

                if (data.paymentInstrumentsDetails.isNotFullyCoveredByAny) {
                    if ($selectedPaymentOption.val() === checkoutConstants.PAYMENT_METHODS.LOYALTY) {
                        $('#selectedPaymentOption').val('');
                    }

                    $('.gift-card-promo-entry-content').slideDown();
                    $paymentOptionsBlock.removeClass('d-none').slideDown().data('fully-covered', false);
                } else {
                    $paymentOptionsBlock.slideUp().data('fully-covered', true);

                    $('.submit-payment').removeClass('d-none').addClass('d-block');
                    $('.checkout-accordion.review').removeClass('d-none');

                    $('#selectedPaymentOption').val(checkoutConstants.PAYMENT_METHODS.LOYALTY);
                    $('.gift-card-promo-entry-content').slideUp();
                    giftCardHelpers.updateCreditCardFields(false);
                }

                giftCardHelpers.updatePaymentsection(data.result);
                updateForecastedRewards(data.result.rewards);
                basketHelper.updateRewardsCardAndBanner(data);
                return true;
            }).fail(() => {
                if (window.digitalData && window.digitalData.user && window.digitalData.user.rewardsRedeemed) {
                    delete window.digitalData.user.rewardsRedeemed;
                }
                $.spinner().stop();
                // display error modal
                errorModal('Something went wrong. Please try again. If the problem persists, please contact customer support.');
            });
        });

        // Currently we are using a site preference for toggling between the drop down and any increment. As such, we need to look for both selectors
        let $loyaltyRemoveButton = $('.js-loyalty-applied-alert').find('.alert__close-btn');

        if (!$loyaltyRemoveButton.length) {
            $loyaltyRemoveButton = $('.js-btn-remove-loyalty-rewards');
        }

        $loyaltyRemoveButton.on('click', function (e) {
            e.preventDefault(); // prevent the close button from closing the alert
            const $form = $('form.js-apply-loyalty-rewards');
            $form.attr('action', $form.data('cancelUrl'));
            $form.trigger('submit');
        });
    },
    updateForecastedRewards: updateForecastedRewards,
    rewardsBalanceBannerToggle
};
